import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"
import { usePwaHelpers } from "./concerns/use_pwa_helpers";

// en el link poner data-controller="ios-pwa-open-in-safari"
// si estoy en ios con la app instalada y el enlace es HTTPS hacia una app permitida, lo abre en Safari
export default class extends Controller {
  initialize() {
    Loggable(this, { debug: false })
    usePwaHelpers(this)
  }

  connect() {
    this.log("connected")
    if (this.isIos() && this.isInstalled() && this.hrefIsSsl() && this.hrefOpensInSafari()){
      this.log("adding x-safari- to href")
      this.element.href = "x-safari-" + this.element.href
    }
  }

  hrefIsSsl(){
    return new URL(this.element.href).protocol === "https:"
  }

  hrefOpensInSafari(){
    return ["crm.padm.am", "crm.derose.app", "ebooks.derose.app"].includes(new URL(this.element.href).hostname)
  }

}
